var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA90C",
    d: "M5.106 1.789a1 1 0 0 1 1.788 0l4.382 8.764A1 1 0 0 1 10.382 12H1.618a1 1 0 0 1-.894-1.447z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.141 5.99c-.055-.387-.082-.58-.006-.724a.5.5 0 0 1 .147-.17C5.414 5 5.61 5 6 5s.586 0 .718.096a.5.5 0 0 1 .147.17c.076.144.049.337-.006.724L6.54 8.214c-.02.136-.03.204-.076.245-.047.041-.116.041-.254.041h-.422c-.138 0-.207 0-.254-.04-.047-.042-.056-.11-.076-.246z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10.167,
    r: 1,
    fill: "#fff"
  })));
};
export default SvgWarning;